"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyBeam = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var components_1 = require("../../shared/components");
var change_tracking_1 = require("../utils/change-tracking");
var StrategyNameEditor_1 = require("./StrategyNameEditor");
/**
 * StrategyBeam - Strategy selector dropdown with inline add / rename / delete
 * actions. Wraps {@link StrategyNameEditor} when the user enters edit mode.
 */
exports.StrategyBeam = function (_a) {
    var strategies = _a.strategies, selectedStrategyId = _a.selectedStrategyId, isLoading = _a.isLoading, isStrategyValid = _a.isStrategyValid, _b = _a.hasLoadError, hasLoadError = _b === void 0 ? false : _b, editMode = _a.editMode, nameInput = _a.nameInput, onSelectStrategy = _a.onSelectStrategy, onStartAdd = _a.onStartAdd, onStartEdit = _a.onStartEdit, onDelete = _a.onDelete, onConfirm = _a.onConfirm, onCancelEdit = _a.onCancelEdit, onNameInputChange = _a.onNameInputChange;
    var _c = components_1.useConfirmDialog(), confirm = _c.confirm, confirmDialog = _c.dialog;
    var dropdownOptions = strategies.map(function (s) { return ({
        key: s.id,
        text: s.name,
    }); });
    return (react_1.default.createElement("div", { className: "ws-strategy-beam" },
        editMode ? (react_1.default.createElement(StrategyNameEditor_1.StrategyNameEditor, { mode: editMode, value: nameInput, onChange: onNameInputChange, onConfirm: onConfirm, onCancel: onCancelEdit })) : (react_1.default.createElement("div", { className: "ws-strategy-beam-view" },
            react_1.default.createElement(Dropdown_1.Dropdown, { key: isStrategyValid ? "strategy-" + selectedStrategyId : 'strategy-none', label: "Working on strategy", selectedKey: isStrategyValid ? selectedStrategyId || undefined : undefined, options: dropdownOptions, disabled: isLoading || strategies.length === 0, onChange: function (_, option) {
                    if (!option)
                        return;
                    var newStrategyId = option.key;
                    if (newStrategyId === selectedStrategyId)
                        return;
                    // Orchestrator owns the discard-unsaved-changes confirmation
                    // so the prompt is not shown twice.
                    onSelectStrategy(newStrategyId);
                }, placeholder: dropdownOptions.length === 0 ? 'No strategies available' : 'Select a strategy', styles: { root: { width: 260 } } }),
            react_1.default.createElement("div", { className: "ws-strategy-beam-actions" },
                react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'Edit' }, title: "Rename selected strategy", ariaLabel: "Rename strategy", className: "ws-admin-button-hover-accent", disabled: !isStrategyValid || isLoading, onClick: onStartEdit }),
                react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'Delete' }, title: "Delete selected strategy", ariaLabel: "Delete strategy", className: "ws-admin-button-hover-danger", disabled: !isStrategyValid || isLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var stratName, ok;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    stratName = ((_a = strategies.find(function (s) { return s.id === selectedStrategyId; })) === null || _a === void 0 ? void 0 : _a.name) || 'this strategy';
                                    return [4 /*yield*/, confirm({
                                            title: 'Delete strategy',
                                            message: "Delete \u201C" + change_tracking_1.truncateForDisplay(stratName) + "\u201D?",
                                            subText: 'This action cannot be undone.',
                                            variant: 'error',
                                            confirmText: 'Delete',
                                        })];
                                case 1:
                                    ok = _b.sent();
                                    if (ok)
                                        onDelete();
                                    return [2 /*return*/];
                            }
                        });
                    }); } })),
            react_1.default.createElement(Button_1.DefaultButton, { text: "Add strategy", iconProps: { iconName: 'Add' }, title: hasLoadError ? 'Reload before adding a new strategy' : 'Add a new strategy', ariaLabel: "Add a new strategy", className: "ws-admin-button-add ws-admin-button-hover-accent", onClick: onStartAdd, disabled: isLoading || hasLoadError }))),
        confirmDialog));
};
